<template>
  <template v-if="!!link">
    <div v-if="disabled" :class="[cssClass, 'opacity-50 inline-flex items-center justify-center h-12 px-3 sm:px-6 py-3']">{{ label }}</div>
    <a v-else :href="link" :class="cssClass">
      <span class="btn-primary__front">{{ label }}</span>
      <span class="btn-primary__back" aria-hidden="true">{{ label }}</span>
    </a>
  </template>
  <template v-else>
    <button :class="cssClass"
            @click="$emit('click', $event)"
            :disabled="disabled">
      <span class="btn-primary__front">{{ label }}</span>
      <span class="btn-primary__back" aria-hidden="true">{{ label }}</span>
    </button>
  </template>
</template>

<script setup>
const props = defineProps([
  'link',
  'label',
  'cssClass',
  'disabled'
]);
const emit = defineEmits(['click']);
</script>
